"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.addLuggageToTravellers = addLuggageToTravellers;
exports.generateTravellerHashMap = generateTravellerHashMap;
exports.getDocumentTypes = getDocumentTypes;
exports.getFlightTravellers = getFlightTravellers;
exports.getIssuingCountries = getIssuingCountries;
exports.getTravellerTypeFromBirthDate = getTravellerTypeFromBirthDate;
exports.getTravellersPayloadFromState = getTravellersPayloadFromState;
exports.hashSavedTraveller = hashSavedTraveller;
exports.isTravellerFilled = isTravellerFilled;
exports.isValidTravellersState = isValidTravellersState;
exports.sortTravellers = sortTravellers;
exports.updateTravellerBirthDateState = updateTravellerBirthDateState;
exports.updateTravellerIdState = updateTravellerIdState;
exports.updateTravellerState = updateTravellerState;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _traveller = _interopRequireDefault(require("../factories/traveller.factory"));
var _travellerPayload = _interopRequireDefault(require("../factories/traveller-payload.factory"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _get_date = _interopRequireDefault(require("date-fns/get_date"));
var _get_month = _interopRequireDefault(require("date-fns/get_month"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _get_year = _interopRequireDefault(require("date-fns/get_year"));
var _difference_in_calendar_days = _interopRequireDefault(require("date-fns/difference_in_calendar_days"));
var _pax = require("./pax.utils");
var _constants = require("../constants");
var _excluded = ["frequentFlyer"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getFlightTravellers(_ref) {
  var pax = _ref.pax,
    travellers = _ref.travellers,
    ssr = _ref.ssr,
    vendor = _ref.vendor,
    hasFrequentFlyerOptions = _ref.hasFrequentFlyerOptions,
    hasMealOptions = _ref.hasMealOptions,
    $currency = _ref.$currency;
  var indexByTypeMap = (0, _mapValues2.default)(_constants.TRAVELLERS_TYPES_CODES_MAP, function () {
    return 0;
  });
  var travellerHashMap = generateTravellerHashMap(travellers);
  var unsortedTravellers = (0, _map2.default)(pax, function (paxUnit) {
    var _paxUnit$info, _paxUnit$info2, _travellerHashMap$gen;
    var seatIndex = paxUnit === null || paxUnit === void 0 ? void 0 : (_paxUnit$info = paxUnit.info) === null || _paxUnit$info === void 0 ? void 0 : _paxUnit$info.ref;
    var type = paxUnit === null || paxUnit === void 0 ? void 0 : (_paxUnit$info2 = paxUnit.info) === null || _paxUnit$info2 === void 0 ? void 0 : _paxUnit$info2.type;
    var traveller = (_travellerHashMap$gen = travellerHashMap === null || travellerHashMap === void 0 ? void 0 : travellerHashMap[(0, _pax.generatePaxId)(type, seatIndex)]) !== null && _travellerHashMap$gen !== void 0 ? _travellerHashMap$gen : {};
    var flightTraveller = (0, _traveller.default)({
      traveller: traveller,
      paxUnit: paxUnit,
      ssr: (0, _find2.default)(ssr, {
        seatIndex: seatIndex
      }),
      $currency: $currency,
      vendor: vendor,
      hasFrequentFlyerOptions: hasFrequentFlyerOptions,
      hasMealOptions: hasMealOptions
    });
    flightTraveller.indexByType = indexByTypeMap[type];
    indexByTypeMap[type]++;
    return flightTraveller;
  });
  return sortTravellers(unsortedTravellers);
}
function getTravellersPayloadFromState(travellersValues) {
  return (0, _map2.default)(travellersValues, _travellerPayload.default);
}
function generateTravellerHashMap(travellers) {
  return (0, _keyBy2.default)(travellers, function (traveller) {
    var _traveller$additional;
    return (0, _pax.generatePaxId)(traveller === null || traveller === void 0 ? void 0 : traveller.type, traveller === null || traveller === void 0 ? void 0 : (_traveller$additional = traveller.additionalData) === null || _traveller$additional === void 0 ? void 0 : _traveller$additional.seatIndex);
  });
}
function getTravellerTypeFromBirthDate(birthDate, flightDate) {
  var currentDate = (0, _pax.isHijri)(birthDate) ? (0, _format.default)((0, _pax.convertGregorianToHijriDate)(new Date(flightDate))) : (0, _format.default)(new Date(flightDate));
  var age = (0, _difference_in_calendar_days.default)(currentDate, new Date(birthDate));
  var adultAge = _constants.ADULT_MIN_AGE * 365.25;
  var infantAge = _constants.INFANT_MAX_AGE * 365.25;
  if (age < adultAge && age > infantAge) {
    return _constants.TRAVELLERS_TYPES_CODES_MAP.CH;
  }
  if (age <= infantAge) {
    return _constants.TRAVELLERS_TYPES_CODES_MAP.INF;
  }
  return _constants.TRAVELLERS_TYPES_CODES_MAP.ADT;
}
function updateTravellerState(travellerState, payload) {
  if (!(0, _isPlainObject2.default)(payload) || (0, _isEmpty2.default)(payload)) {
    return travellerState;
  }
  var frequentFlyer = payload.frequentFlyer,
    remainPayload = (0, _objectWithoutPropertiesLoose2.default)(payload, _excluded);
  var nextTravellerState = _objectSpread(_objectSpread({}, travellerState), remainPayload);
  if (nextTravellerState.hasAdvancedOptions && frequentFlyer) {
    (0, _set2.default)(nextTravellerState, 'ssr.frequentFlyer', frequentFlyer);
  }
  var birthDateState = updateTravellerBirthDateState(nextTravellerState);
  var idState = updateTravellerIdState(nextTravellerState);
  return _objectSpread(_objectSpread(_objectSpread({}, nextTravellerState), birthDateState), idState);
}
function updateTravellerBirthDateState(travellerState) {
  var birthDateState = {};
  var birthDate = new Date(travellerState.birthDate || 'Invalid Date');
  birthDateState.birthDateIsHijri = Boolean(travellerState.birthDateIsHijri);
  if (!travellerState.isNationalIdRequired && travellerState.birthDateIsHijri) {
    birthDateState.birthDateIsHijri = false;
    birthDate = (0, _pax.convertHijriToGregorianDate)(travellerState.birthDate);
  }
  birthDateState.birthDate = birthDate;
  birthDateState.birthDateDay = (0, _get_date.default)(birthDate);
  birthDateState.birthDateMonth = (0, _get_month.default)(birthDate);
  birthDateState.birthDateYear = (0, _get_year.default)(birthDate);
  return birthDateState;
}
function updateTravellerIdState(travellerState) {
  var idState = {};
  idState.idExpiryDateIsHijri = Boolean(travellerState.idExpiryDateIsHijri);
  var idExpiryDate = new Date(travellerState.idExpiryDate || 'Invalid Date');
  if (!travellerState.isNationalIdRequired && travellerState.idExpiryDateIsHijri || travellerState.idType === _constants.ID_TYPES.PASSPORT && travellerState.idExpiryDateIsHijri) {
    idState.idExpiryDateIsHijri = false;
    idExpiryDate = (0, _pax.convertHijriToGregorianDate)(travellerState.idExpiryDate);
  }
  if (!travellerState.isNationalIdRequired && travellerState.idType !== _constants.ID_TYPES.PASSPORT) {
    idState.idType = _constants.ID_TYPES.PASSPORT;
    idState.idNumber = undefined;
    idExpiryDate = new Date('Invalid Date');
  }
  idState.idExpiryDate = idExpiryDate;
  idState.idExpiryDateDay = (0, _get_date.default)(idExpiryDate);
  idState.idExpiryDateMonth = (0, _get_month.default)(idExpiryDate);
  idState.idExpiryDateYear = (0, _get_year.default)(idExpiryDate);
  return idState;
}
function isTravellerFilled(travellerState) {
  var requiredValues = _constants.TRAVELLER_REQUIRED_VALUES.BASIC;
  if (travellerState.isIDRequired) {
    requiredValues = requiredValues.concat(_constants.TRAVELLER_REQUIRED_VALUES.ID_REQUIRED);
  }
  if (travellerState.isAPIsRequired) {
    requiredValues = requiredValues.concat(_constants.TRAVELLER_REQUIRED_VALUES.APIS_REQUIRED);
  }
  if (travellerState.isDateOfBirthRequired) {
    requiredValues = requiredValues.concat(_constants.TRAVELLER_REQUIRED_VALUES.DOB_REQUIRED);
  }
  return requiredValues.every(function (value) {
    return Boolean(travellerState[value]) || !isNaN(Number(travellerState[value]));
  });
}
function hashSavedTraveller(_ref2) {
  var title = _ref2.title,
    firstName = _ref2.firstName,
    middleName = _ref2.middleName,
    lastName = _ref2.lastName;
  return (0, _toLower2.default)(title + "." + firstName + "." + middleName + "." + lastName);
}
function isValidTravellersState(travellers) {
  if ((0, _size2.default)(travellers) === 0) {
    return false;
  }
  (0, _each2.default)(travellers, function (traveller) {
    if (!(0, _isPlainObject2.default)(traveller) || !(0, _has2.default)(traveller, ['id', 'type', 'seatIndex'])) {
      return false;
    }
  });
  return true;
}
function getDocumentTypes(documentTypes, countryCode) {
  if ((0, _isEmpty2.default)(countryCode)) {
    return [_constants.ID_TYPES.PASSPORT];
  }
  var availableDocumentTypes = (0, _filter2.default)(documentTypes, function (item) {
    var _item$nationality, _item$nationality2;
    var hasEnabled = item === null || item === void 0 ? void 0 : item.enabled;
    var includeItems = item === null || item === void 0 ? void 0 : (_item$nationality = item.nationality) === null || _item$nationality === void 0 ? void 0 : _item$nationality.include;
    var excludeItems = item === null || item === void 0 ? void 0 : (_item$nationality2 = item.nationality) === null || _item$nationality2 === void 0 ? void 0 : _item$nationality2.exclude;
    if (!hasEnabled) {
      return false;
    }
    if ((0, _isArray2.default)(includeItems)) {
      return includeItems.includes(countryCode) || includeItems.includes('*');
    }
    if ((0, _isArray2.default)(excludeItems)) {
      return !excludeItems.includes(countryCode);
    }
    return false;
  });
  return (0, _map2.default)(availableDocumentTypes, 'type');
}
function getIssuingCountries(documentTypes, countryList, selectedDocumentType) {
  var _availableIssuingCoun, _availableIssuingCoun2;
  if ((0, _isEmpty2.default)(selectedDocumentType)) {
    return [];
  }
  var availableIssuingCountries = (0, _find2.default)(documentTypes, {
    enabled: true,
    type: selectedDocumentType
  });
  var issuingCountries = (_availableIssuingCoun = availableIssuingCountries === null || availableIssuingCountries === void 0 ? void 0 : (_availableIssuingCoun2 = availableIssuingCountries.issuingCountry) === null || _availableIssuingCoun2 === void 0 ? void 0 : _availableIssuingCoun2.include) !== null && _availableIssuingCoun !== void 0 ? _availableIssuingCoun : [];
  var hasAllCountries = (0, _some2.default)(issuingCountries, function (c) {
    return c === '*';
  });
  return hasAllCountries ? countryList : (0, _filter2.default)(countryList, function (_ref3) {
    var code = _ref3.code;
    return issuingCountries.includes(code);
  });
}
function sortTravellers(travellers) {
  var infants = (0, _filter2.default)(travellers, 'isInfant').reverse();
  return travellers.reduce(function (acc, traveller) {
    var infantInLab = traveller.isAdult && infants.length;
    if (!traveller.isInfant) {
      infantInLab ? acc.push(_objectSpread(_objectSpread({}, traveller), {}, {
        infantInLab: true
      })) : acc.push(traveller);
    }
    if (infantInLab) {
      acc.push(infants.pop());
    }
    return acc;
  }, []);
}
function addLuggageToTravellers(travellers, luggage) {
  return (0, _map2.default)(travellers, function (traveller) {
    if (!(0, _isPlainObject2.default)(traveller)) return traveller;
    var ssr = (0, _isPlainObject2.default)(traveller.ssr) ? traveller.ssr : {};
    return _objectSpread(_objectSpread({}, traveller), {}, {
      ssr: _objectSpread(_objectSpread({}, ssr), {}, {
        luggage: luggage
      })
    });
  });
}